/* ORRA Glam: 3 balanced fragrance tiles, with product-specific evidence. Unpublished theme.
   Override data sources: brand / perfumery reference descriptions, used only when product
   text does not have enough notes. Reference note profiles are NOT ingredient guarantees.
   Burning Rose: carolinaherrera.com/uk/en/p-fragrance/burning-rose
   Yara: lattafa.com/product/yara/
   Devotion: sephora.com/product/devotion-eau-de-parfum-P508461
   My Way Intense: giorgioarmanibeauty.com.au/fragrances/womens-fragrances/my-way-perfume-for-her/my-way-eau-de-parfum-intense/ww-00537-arm.html
   Purple Oud: fragrantica.com/perfume/Dior/Purple-Oud-48376.html
   Ombre Nomade: me.louisvuitton.com/eng-ae/products/ombre-nomade-nvprod990245v/LP0096
   Le Male Elixir: jeanpaulgaultier.com/ww/en/fragrances/range-le-male/le-male-elixir-parfum
   Ultra Male: fragrantica.com/perfume/Jean-Paul-Gaultier/Ultra-Male-30947.html
   Megamare: nordstrom.com/s/orto-parisi-megamare-parfum-50ml/9341620
   Paradoxe Radical Essence: prada-beauty.com/fragrance/paradoxe/paradoxe-radical-essence-parfum/MPL01825.html
*/
(function(){
'use strict';
function norm(x){return String(x||'').replace(/\u00a0/g,' ').replace(/&amp;/g,'&').replace(/\s+/g,' ').trim();}
function titlecase(x){return norm(x).toLowerCase().replace(/\b[a-z]/g,function(c){return c.toUpperCase();});}
function stage(text,re){
 var m=re.exec(text);if(!m)return '';
 var p=text.slice(m.index+m[0].length,m.index+m[0].length+130);
 p=p.split(/[.;]|\b(?:middle|base|top)\s+notes?\b|\b(?:heart|opening|base)\s*:/i)[0];
 p=p.split(/,|\s+and\s+|\s*&\s*|\s+[–—]\s+/i)[0];
 p=p.replace(/^[\s:–—-]+/,'').trim();
 if(!p||p.length>45||/\b(fragrance|collection|perfume|women|men|scent|experience|notes|heart|base)\b/i.test(p))return '';
 return titlecase(p);
}
var keywords=['passion fruit','passionfruit','bitter orange','orange blossom','pink pepper','blackcurrant','sandalwood','tonka bean','white musk','chocolate fudge','whipped cream','marshmallow','raspberry','strawberry','bergamot','vanilla','amber','rose','jasmine','patchouli','lavender','musk','leather','tobacco','coffee','caramel','iris','vetiver','cinnamon','saffron','mint','cocoa','cookie','almond','honey','pear','apple','mango','pineapple','peach','lemon','ginger','cardamom','incense','oud','cedar','freesia','gardenia','grapefruit','marine','mandarin','violet','cypress','basil','neroli','benzoin','labdanum','magnolia','geranium','lime','plum','lily','frosting','cupcake','coconut','frangipani','apricot','fig','tea','guaiac wood','cashmeran','black pepper','peru balsam','damask rose','turkish rose','milk','sugar','butter','cherry','tuberose','ylang ylang','pistachio','orchid','heliotrope','tangerine','seaweed','calone','ambroxan','neroli','black vanilla','bulgarian rose'];
function trimCatalogIntro(text){
 var match=/^.{0,260}?\bby\b.{0,120}?\bis an?\s+.{3,60}?\bfragrance\b[^.]*\./i.exec(text);
 if(match)text=norm(text.slice(match[0].length));
 return text.replace(/[^.!?]{0,140}\b(?:launched in|nose behind|created by)\b[^.!?]*[.!?]/gi,' ');
}
function highlights(text){
 var source=trimCatalogIntro(text).toLowerCase(),found=[];
 keywords.forEach(function(w){
  var pos=source.indexOf(w.toLowerCase());
  if(pos<0)return;
  var before=pos>0?source.charAt(pos-1):' ',after=source.charAt(pos+w.length)||' ';
  if(/[a-z]/.test(before)||/[a-z]/.test(after))return;
  found.push({word:titlecase(w),pos:pos});
 });
 found.sort(function(a,b){return a.pos-b.pos});
 var chosen=[];
 found.forEach(function(v){
  if(chosen.length>=3)return;
  if(chosen.some(function(n){var a=n.toLowerCase(),b=v.word.toLowerCase();return a===b||a.indexOf(b)>-1||b.indexOf(a)>-1;}))return;
  chosen.push(v.word);
 });
 return chosen;
}
function family(text){
 var m=/\bis an?\s+([a-z][a-z /-]{2,65}?)\s+fragrance\b/i.exec(text);
 return m?titlecase(m[1]).slice(0,34):'';
}
function marketProfile(name){
 // Explicit, title-scoped overrides for independently researched reference perfumes.
 var curated=[
  [/burning rose/i,['TOP','Black Pepper','HEART','Bulgarian Rose','BASE','Patchouli']],
  [/\bdevotion\b(?!.*(?:intense|gift))/i,['TOP','Candied Lemon','HEART','Orange Blossom','BASE','Vanilla']],
  [/^yara eau de parfum/i,['TOP','Orchid','HEART','Tropical Fruits','BASE','Vanilla']],
  [/\bmy way intense\b/i,['TOP','Orange Blossom','HEART','Tuberose','BASE','Sandalwood']],
  [/\bpurple oud\b/i,['NOTE','Orange','NOTE','Oud','NOTE','Saffron']],
  [/\bombr[eé] nomade\b/i,['NOTE','Oud Wood','NOTE','Benzoin','NOTE','Raspberry']],
  [/\ble male elixir\b/i,['TOP','Lavender','HEART','Tonka Bean','BASE','Benzoin']],
  [/\bultra male intense\b/i,['TOP','Pear','HEART','Cinnamon','BASE','Vanilla']],
  [/\bmegamare\b/i,['TOP','Bergamot','HEART','Seaweed','BASE','Musk']]
 ];
 for(var i=0;i<curated.length;i++)if(curated[i][0].test(name)){
  var x=curated[i][1];
  return {title:'THE SCENT SIGNATURE',cards:[[x[0],x[1]],[x[2],x[3]],[x[4],x[5]]]};
 }
 return null;
}
function specialSet(name,text){
 if(/^duran trio\b/i.test(name))return {title:'THE FRAGRANCE COLLECTION',cards:[['MOOD 01','Burgundy'],['MOOD 02','Warm Beige'],['MOOD 03','Earthy Olive']]};
 if(/^ibraq musk collection\b/i.test(name))return {title:'THE FRAGRANCE COLLECTION',cards:[['BLEND','Six Musk Scents'],['CHARACTER','Fresh & Soft'],['STYLE','Gift Collection']]};
 if(/^tobacco collection 9\b/i.test(name))return {title:'THE FRAGRANCE COLLECTION',cards:[['BLEND 01','Mexican Tobacco'],['BLEND 02','Jamaican Tobacco'],['BLEND 03','Cuban Tobacco']]};
 if(/^diamond collection\s+set/i.test(name))return {title:'THE FRAGRANCE COLLECTION',cards:[['SCENT 01','Black Carbon'],['SCENT 02','Purple Heart'],['SCENT 03','Grey Pearl']]};
 if(/^paradoxe gift set/i.test(name))return {title:'THE FRAGRANCE COLLECTION',cards:[['SCENT 01','Paradoxe EDP'],['SCENT 02','Radical Essence'],['SET','30 + 90 ML']]};
 return null;
}
function add(host,label,value){
 var chip=document.createElement('div');
 chip.className='orra-scent-signature__note';
 var l=document.createElement('span');l.className='orra-scent-signature__note-label';l.textContent=label;
 var v=document.createElement('span');v.className='orra-scent-signature__note-value';v.textContent=value;
 chip.append(l,v);host.appendChild(chip);
}
function optionsFromText(text,title){
 var set=specialSet(title,text);
 if(set)return set;
 var explicit=[
  ['TOP',stage(text,/\b(?:top\s+notes?|opening)\s*(?:are|is|:)\s*/i)],
  ['HEART',stage(text,/\b(?:middle\s+notes?|heart\s+notes?)\s*(?:are|is|:)\s*|\bheart\s*:\s*/i)],
  ['BASE',stage(text,/\bbase\s+notes?\s*(?:are|is|:)\s*|\bbase\s*:\s*/i)]
 ].filter(function(x){return !!x[1]});
 if(explicit.length===3)return {title:'THE SCENT SIGNATURE',cards:explicit};
 var curated=marketProfile(title);
 if(curated)return curated;
 // COUTURE description labels the notes differently from most imports; still sourced.
 if(/^couture\s+[—-]/i.test(title))return {title:'THE SCENT SIGNATURE',cards:[['TOP','Fruity Citrus'],['HEART','Fresh Florals'],['BASE','Soft Musk']]};
 var tiles=explicit.slice();
 highlights(text).forEach(function(n){
  if(tiles.length>=3)return;
  if(tiles.some(function(x){var a=x[1].toLowerCase(),b=n.toLowerCase();return a===b||a.indexOf(b)>=0||b.indexOf(a)>=0;}))return;
  tiles.push(['NOTE',n]);
 });
 if(tiles.length===3)return {title:explicit.length===3?'THE SCENT SIGNATURE':'SCENT HIGHLIGHTS',cards:tiles};
 // Don't fabricate missing notes: the remaining chips are factual product attributes.
 var f=family(text);
 if(f&&tiles.length<3)tiles.push(['FAMILY',f]);
 var match=text.match(/\bfor (?:women and men|men and women|women|men)\b/i);
 if(match&&tiles.length<3)tiles.push(['FOR',/women and men|men and women/i.test(match[0])?'Unisex':/women/i.test(match[0])?'Women':'Men']);
 var type=/\b(?:set|collection|gift set)\b/i.test(title)?'Fragrance Set':/\b(?:eau de toilette|edt)\b/i.test(title)?'Eau de Toilette':/\b(?:eau de parfum|edp)\b/i.test(title)?'Eau de Parfum':/\bparfum\b/i.test(title)?'Parfum':'Fragrance';
 if(tiles.length<3)tiles.push(['TYPE',type]);
 if(tiles.length<3)tiles.push(['DETAILS','See Description']);
 if(tiles.length<3)tiles.push(['PROFILE','Discover More']);
 return {title:explicit.length?'SCENT HIGHLIGHTS':'THE FRAGRANCE PROFILE',cards:tiles.slice(0,3)};
}
function initialize(root){
 if(root.dataset.scentReady==='true')return;
 var source=root.querySelector('[data-orra-scent-source]');
 var tiles=root.querySelector('[data-orra-scent-notes]');
 var summary=root.querySelector('[data-orra-scent-summary]');
 var heading=root.querySelector('[data-orra-scent-title]');
 if(!source||!tiles||!heading||!summary)return;
 var text=norm(source.textContent).replace(/^product description\s*/i,'');
 var name=norm(root.dataset.productTitle);
 if(name&&text.toLowerCase().indexOf(name.toLowerCase())===0)text=norm(text.slice(name.length));
 var config=optionsFromText(text,name);
 tiles.replaceChildren();
 config.cards.forEach(function(x){add(tiles,x[0],x[1]);});
 tiles.style.setProperty('--orra-note-count','3');
 tiles.hidden=false;summary.hidden=true;
 heading.textContent=config.title;
 root.classList.remove('orra-scent-signature--compact');
 root.dataset.scentReady='true';
}
function scan(){document.querySelectorAll('[data-orra-scent-signature]').forEach(initialize);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',scan);
})();